import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = {
  key: 0,
  style: {"height":"100%"}
}
const _hoisted_2 = { class: "mr-2" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["colspan"]
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "mr-2" }
const _hoisted_29 = { class: "d-flex justify-space-between" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_accountable_account = _resolveComponent("accountable-account")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_DocumentReconciliator = _resolveComponent("DocumentReconciliator")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_flex = _resolveComponent("v-flex")!
  const _component_oss_date_range_picker = _resolveComponent("oss-date-range-picker")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_slide_y_transition = _resolveComponent("v-slide-y-transition")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_WithoutInvoice = _resolveComponent("WithoutInvoice")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_ThirdPartyCompany = _resolveComponent("ThirdPartyCompany")!
  const _component_AutoSales = _resolveComponent("AutoSales")!
  const _component_Commission = _resolveComponent("Commission")!
  const _component_Loan = _resolveComponent("Loan")!
  const _component_CutAccountingLine = _resolveComponent("CutAccountingLine")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_ZTill = _resolveComponent("ZTill")!
  const _component_CurrentAccount = _resolveComponent("CurrentAccount")!
  const _component_CashPayment = _resolveComponent("CashPayment")!
  const _component_Remittance = _resolveComponent("Remittance")!
  const _component_CashWithdrawal = _resolveComponent("CashWithdrawal")!
  const _component_document = _resolveComponent("document")!
  const _component_IOPBankTransactionDialog = _resolveComponent("IOPBankTransactionDialog")!

  return (_ctx.groupedAccountingLines)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.inbeddedMode && !_ctx.$vuetify.display.mobile)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex flex-row pa-2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        (_ctx.mode != 'GeneralLedger')
                          ? (_openBlock(), _createBlock(_component_v_btn_back, {
                              key: 0,
                              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.back()), ["stop"]))
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_v_btn_icon, {
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.help()), ["stop"])),
                          class: "ml-3",
                          size: "small",
                          icon: "$fa-question"
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_window, {
                        modelValue: _ctx.wizardStep,
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.wizardStep) = $event)),
                        touchless: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_window_item, { value: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_container, { fluid: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_data_table, {
                                            headers: _ctx.groupItemsHeaders2,
                                            items: _ctx.groupedAccountingLines,
                                            "hide-default-footer": "",
                                            "items-per-page": -1,
                                            class: "table",
                                            "fixed-header": "",
                                            "max-height": "60vh",
                                            loading: _ctx.loading,
                                            style: {"width":"100%"},
                                            xs12: ""
                                          }, {
                                            item: _withCtx(({ item, index }) => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (accountingItem, alIndex) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                  style: _normalizeStyle(
                                                        alIndex === 0
                                                            ? 'cursor: pointer; border-top;font-weight: bold;'
                                                            : 'cursor: pointer'
                                                    ),
                                                  key: index + '-' + alIndex,
                                                  onClick: _withModifiers(($event: any) => (
                                                        _ctx.addRemoveReconciliationExpend(
                                                            accountingItem,
                                                        )
                                                    ), ["stop"])
                                                }, [
                                                  _createElementVNode("td", {
                                                    class: "text-center",
                                                    style: _normalizeStyle(_ctx.getCellStyle(alIndex, false))
                                                  }, [
                                                    _createVNode(_component_v_icon, {
                                                      small: true,
                                                      class: "mr-2"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.formatIconName(accountingItem.iconType)), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ], 4),
                                                  _createElementVNode("td", {
                                                    class: "text-left",
                                                    style: _normalizeStyle(_ctx.getCellStyle(alIndex, false))
                                                  }, [
                                                    _createElementVNode("div", null, [
                                                      (
                                                                    (accountingItem.bt &&
                                                                        accountingItem.bt
                                                                            .accountingItemImport) ||
                                                                    (accountingItem.doc &&
                                                                        accountingItem.doc
                                                                            .accountingItemImport)
                                                                )
                                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                                            key: 0,
                                                            label: "",
                                                            color: "grey",
                                                            class: "mr-2",
                                                            size: "small",
                                                            variant: "outlined"
                                                          }, {
                                                            default: _withCtx(() => _cache[70] || (_cache[70] = [
                                                              _createTextVNode("Importé")
                                                            ])),
                                                            _: 1
                                                          }))
                                                        : _createCommentVNode("", true),
                                                      _createTextVNode(_toDisplayString(accountingItem.name), 1)
                                                    ]),
                                                    (accountingItem.bt)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                          (accountingItem.suppliers)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Fournisseur: " + _toDisplayString(accountingItem.suppliers), 1))
                                                            : _createCommentVNode("", true),
                                                          (accountingItem.customers)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Client: " + _toDisplayString(accountingItem.customers), 1))
                                                            : _createCommentVNode("", true),
                                                          (accountingItem.user)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Collaborateur : " + _toDisplayString(accountingItem.user), 1))
                                                            : _createCommentVNode("", true),
                                                          (accountingItem.bankAccount)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Compte bancaire : " + _toDisplayString(accountingItem.bankAccount), 1))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      : _createCommentVNode("", true),
                                                    (
                                                                accountingItem.accountingLine.id &&
                                                                accountingItem.accountingLine
                                                                    .bankTransaction
                                                            )
                                                      ? (_openBlock(), _createBlock(_component_FreeTag, {
                                                          key: 1,
                                                          companyTags: _ctx.allCompanyTags,
                                                          company: _ctx.selectedCompany,
                                                          documentType: 'BANK_TRANSACTION',
                                                          accountingLine: 
                                                                accountingItem.accountingLine
                                                            
                                                        }, null, 8, ["companyTags", "company", "accountingLine"]))
                                                      : _createCommentVNode("", true),
                                                    (accountingItem.doc)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                          (
                                                                    accountingItem.doc.type ===
                                                                    'WITHOUT_INVOICE'
                                                                )
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Sans justificatif"))
                                                            : (
                                                                    accountingItem.doc.type ===
                                                                    'SALES_INVOICE_AUTO'
                                                                )
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Encaissemment"))
                                                              : _createCommentVNode("", true)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ], 4),
                                                  _createElementVNode("td", {
                                                    class: "text-center",
                                                    style: _normalizeStyle(_ctx.getCellStyle(alIndex, false))
                                                  }, _toDisplayString(accountingItem.date), 5),
                                                  _createElementVNode("td", {
                                                    class: "text-right",
                                                    style: _normalizeStyle(_ctx.getCellStyle(alIndex, false))
                                                  }, [
                                                    (_ctx.isMainItem(item, accountingItem))
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(accountingItem.debit
                                                                    ? _ctx.newCommonFormatCurrency(
                                                                          accountingItem.debit,
                                                                      )
                                                                    : "-"), 1))
                                                      : _createCommentVNode("", true)
                                                  ], 4),
                                                  _createElementVNode("td", {
                                                    class: "text-right",
                                                    style: _normalizeStyle(_ctx.getCellStyle(alIndex, false))
                                                  }, [
                                                    (_ctx.isMainItem(item, accountingItem))
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(accountingItem.credit
                                                                    ? _ctx.newCommonFormatCurrency(
                                                                          accountingItem.credit,
                                                                      )
                                                                    : "-"), 1))
                                                      : _createCommentVNode("", true)
                                                  ], 4),
                                                  (_ctx.isAccountingUser)
                                                    ? (_openBlock(), _createElementBlock("td", {
                                                        key: 0,
                                                        class: "text-center",
                                                        style: _normalizeStyle(_ctx.getCellStyle(alIndex, false))
                                                      }, [
                                                        _createElementVNode("span", {
                                                          style: _normalizeStyle(
                                                                _ctx.getIfNecessaryAccountableAccountColor(
                                                                    item,
                                                                    alIndex,
                                                                )
                                                            )
                                                        }, _toDisplayString(_ctx.getIfNecessaryAccountableAccount(
                                                                    item,
                                                                    alIndex,
                                                                )), 5)
                                                      ], 4))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("td", {
                                                    class: "text-center",
                                                    style: _normalizeStyle(_ctx.getCellStyle(alIndex, false))
                                                  }, [
                                                    (
                                                                alIndex === 0 &&
                                                                _ctx.groupStatusWithoutAA(item)
                                                            )
                                                      ? (_openBlock(), _createBlock(_component_v_chip, {
                                                          key: 0,
                                                          class: "ma-2 font-weight-regular",
                                                          label: "",
                                                          size: "small",
                                                          variant: "outlined"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.groupStatusWithoutAA(item)), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true)
                                                  ], 4),
                                                  (_ctx.isAccountingUser)
                                                    ? (_openBlock(), _createElementBlock("td", {
                                                        key: 1,
                                                        class: "text-center",
                                                        style: _normalizeStyle(_ctx.getCellStyle(alIndex, true))
                                                      }, [
                                                        _createVNode(_component_v_list, {
                                                          rounded: "",
                                                          class: "ma-2",
                                                          density: "compact"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (_ctx.needsAction(item))
                                                              ? (_openBlock(), _createBlock(_component_v_menu, {
                                                                  key: 0,
                                                                  "offset-y": "",
                                                                  activator: 
                                                                    '#more-actions-' +
                                                                    index +
                                                                    '-' +
                                                                    alIndex
                                                                
                                                                }, {
                                                                  activator: _withCtx(({ props }) => [
                                                                    (_ctx.needsAction(item))
                                                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                          key: 0,
                                                                          onClick: _withModifiers(($event: any) => (
                                                                            _ctx.activateActionMenu(
                                                                                $event,
                                                                                item,
                                                                            )
                                                                        ), ["stop"]),
                                                                          id: 
                                                                            'more-actions-' +
                                                                            index +
                                                                            '-' +
                                                                            alIndex
                                                                        
                                                                        }, {
                                                                          append: _withCtx(() => [
                                                                            _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                              default: _withCtx(() => _cache[72] || (_cache[72] = [
                                                                                _createTextVNode("$dots_vertical")
                                                                              ])),
                                                                              _: 1
                                                                            })
                                                                          ]),
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_list_item_title, null, {
                                                                              default: _withCtx(() => _cache[71] || (_cache[71] = [
                                                                                _createTextVNode("Plus d'actions ")
                                                                              ])),
                                                                              _: 1
                                                                            })
                                                                          ]),
                                                                          _: 2
                                                                        }, 1032, ["onClick", "id"]))
                                                                      : _createCommentVNode("", true)
                                                                  ]),
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list, { density: "compact" }, {
                                                                      default: _withCtx(() => [
                                                                        (
                                                                            _ctx.getToReconciliateBTWithDocuments(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 0,
                                                                              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.documentPanel =
                                                                                !_ctx.documentPanel;
                                                                            _ctx.suggestedDocumentPanel = false;
                                                                            _ctx.bankTransactionPanel = false;
                                                                            _ctx.reconciliationPanel = false;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              append: _withCtx(() => [
                                                                                _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                                  default: _withCtx(() => _cache[73] || (_cache[73] = [
                                                                                    _createTextVNode("$fa-search")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => _cache[74] || (_cache[74] = [
                                                                                    _createTextVNode("Chercher un justificatif")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.showSuggestedDocuments(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 1,
                                                                              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.suggestedDocumentPanel =
                                                                                !_ctx.suggestedDocumentPanel;
                                                                            _ctx.documentPanel = false;
                                                                            _ctx.bankTransactionPanel = false;
                                                                            _ctx.reconciliationPanel = false;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              append: _withCtx(() => [
                                                                                _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                                  default: _withCtx(() => _cache[75] || (_cache[75] = [
                                                                                    _createTextVNode("$fa-magic")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => _cache[76] || (_cache[76] = [
                                                                                    _createTextVNode("Justificatifs suggérés")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getWithoutInvoiceBT(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 2,
                                                                              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.showWithoutInvoiceDialog =
                                                                                !_ctx.showWithoutInvoiceDialog;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => _cache[77] || (_cache[77] = [
                                                                                    _createTextVNode("Justificatif manquant")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        _createVNode(_component_v_list_item, {
                                                                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.showIOPBTDialog =
                                                                                !_ctx.showIOPBTDialog;
                                                                        }, ["stop"]))
                                                                        }, {
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_list_item_title, null, {
                                                                              default: _withCtx(() => _cache[78] || (_cache[78] = [
                                                                                _createTextVNode("Lier un document")
                                                                              ])),
                                                                              _: 1
                                                                            })
                                                                          ]),
                                                                          _: 1
                                                                        }),
                                                                        (
                                                                            _ctx.showAutoSalesReconciliation(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 3,
                                                                              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.autoSalesReconciliation =
                                                                                !_ctx.autoSalesReconciliation;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => _cache[79] || (_cache[79] = [
                                                                                    _createTextVNode("Encaissement")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getToReconciliateBTWithDocuments(
                                                                                _ctx.selectedGroup,
                                                                            ) ||
                                                                            _ctx.showSuggestedDocuments(
                                                                                _ctx.selectedGroup,
                                                                            ) ||
                                                                            _ctx.getWithoutInvoiceBT(
                                                                                _ctx.selectedGroup,
                                                                            ) ||
                                                                            _ctx.showAutoSalesReconciliation(
                                                                                _ctx.selectedGroup,
                                                                            ) ||
                                                                            _ctx.getWithDeltaBT(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_divider, { key: 4 }))
                                                                          : _createCommentVNode("", true),
                                                                        (_ctx.cashPaymentDocItem)
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 5,
                                                                              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.showCashPaymentDialog =
                                                                                !_ctx.showCashPaymentDialog;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => _cache[80] || (_cache[80] = [
                                                                                    _createTextVNode("Réglée en espèce")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        (_ctx.cashPaymentDocItem)
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 6,
                                                                              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.showRemittanceDialog =
                                                                                !_ctx.showRemittanceDialog;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => _cache[81] || (_cache[81] = [
                                                                                    _createTextVNode("Chèque|Vir.|Prél. non encaissé")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        (_ctx.cashWithdrawalBTItem)
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 7,
                                                                              onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.showCashWithdrawalDialog =
                                                                                !_ctx.showCashWithdrawalDialog;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => _cache[82] || (_cache[82] = [
                                                                                    _createTextVNode("Retrait en espèce")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getZTillBT(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 8,
                                                                              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.showZTillDialog =
                                                                                !_ctx.showZTillDialog;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => _cache[83] || (_cache[83] = [
                                                                                    _createTextVNode("Réglement du Z de caisse")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.cashPaymentDocItem ||
                                                                            _ctx.cashWithdrawalBTItem ||
                                                                            _ctx.getZTillBT(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_divider, { key: 9 }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getThirdPartyCompanyBTItem(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 10,
                                                                              onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.companyType =
                                                                                'SUPPLIER';
                                                                            _ctx.showThirdPartyCompanyDialog =
                                                                                !_ctx.showThirdPartyCompanyDialog;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => _cache[84] || (_cache[84] = [
                                                                                    _createTextVNode("Règlement fournisseur")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getThirdPartyCompanyBTItem(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 11,
                                                                              onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.companyType =
                                                                                'CUSTOMER';
                                                                            _ctx.showThirdPartyCompanyDialog =
                                                                                !_ctx.showThirdPartyCompanyDialog;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => _cache[85] || (_cache[85] = [
                                                                                    _createTextVNode("Règlement client")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getThirdPartyCompanyBTItem(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_accountable_account, {
                                                                              key: 12,
                                                                              title: 
                                                                            _ctx.subAccountableAccountTitle
                                                                        ,
                                                                              defineThirdParty: true,
                                                                              showLabel: true,
                                                                              showValidation: false,
                                                                              companyId: 
                                                                            _ctx.selectedCompany.id
                                                                        ,
                                                                              inAccountableAccountType: "Selected",
                                                                              embeddedInput: true,
                                                                              editAccountableAccount: 
                                                                            true
                                                                        ,
                                                                              inAccountableAccountNames: 
                                                                            _ctx.subSelectedAccountableAccounts
                                                                        ,
                                                                              activateFreeTag: true,
                                                                              onClose: 
                                                                            _ctx.closeAccountableAccount
                                                                        ,
                                                                              onSelectAccountableAccount: _cache[14] || (_cache[14] = ($event: any) => (
                                                                            _ctx.setAccountableAccount(
                                                                                $event,
                                                                            )
                                                                        ))
                                                                            }, {
                                                                              activator: _withCtx(({
                                                                                props,
                                                                            }) => [
                                                                                (
                                                                                    _ctx.getThirdPartyCompanyBTItem(
                                                                                        _ctx.selectedGroup,
                                                                                    )
                                                                                )
                                                                                  ? (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({
                                                                                      key: 0,
                                                                                      ref_for: true
                                                                                    }, props, {
                                                                                      onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (
                                                                                    _ctx.socialAccountableAccount(
                                                                                        _ctx.selectedGroup,
                                                                                    )
                                                                                ), ["stop"]))
                                                                                    }), {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_v_list_item_title, null, {
                                                                                          default: _withCtx(() => _cache[86] || (_cache[86] = [
                                                                                            _createTextVNode("Règlement social")
                                                                                          ])),
                                                                                          _: 1
                                                                                        })
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1040))
                                                                                  : _createCommentVNode("", true)
                                                                              ]),
                                                                              _: 1
                                                                            }, 8, ["title", "companyId", "inAccountableAccountNames", "onClose"]))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getThirdPartyCompanyBTItem(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_accountable_account, {
                                                                              key: 13,
                                                                              title: 
                                                                            _ctx.subAccountableAccountTitle
                                                                        ,
                                                                              defineThirdParty: true,
                                                                              showLabel: true,
                                                                              showValidation: false,
                                                                              companyId: 
                                                                            _ctx.selectedCompany.id
                                                                        ,
                                                                              inAccountableAccountType: "Selected",
                                                                              embeddedInput: true,
                                                                              editAccountableAccount: 
                                                                            true
                                                                        ,
                                                                              inAccountableAccountNames: 
                                                                            _ctx.subSelectedAccountableAccounts
                                                                        ,
                                                                              activateFreeTag: true,
                                                                              onClose: 
                                                                            _ctx.closeAccountableAccount
                                                                        ,
                                                                              onSelectAccountableAccount: _cache[16] || (_cache[16] = ($event: any) => (
                                                                            _ctx.setAccountableAccount(
                                                                                $event,
                                                                            )
                                                                        ))
                                                                            }, {
                                                                              activator: _withCtx(({
                                                                                props,
                                                                            }) => [
                                                                                (
                                                                                    _ctx.getThirdPartyCompanyBTItem(
                                                                                        _ctx.selectedGroup,
                                                                                    )
                                                                                )
                                                                                  ? (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({
                                                                                      key: 0,
                                                                                      ref_for: true
                                                                                    }, props, {
                                                                                      onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (
                                                                                    _ctx.stateAccountableAccount(
                                                                                        _ctx.selectedGroup,
                                                                                    )
                                                                                ), ["stop"]))
                                                                                    }), {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_v_list_item_title, null, {
                                                                                          default: _withCtx(() => _cache[87] || (_cache[87] = [
                                                                                            _createTextVNode("Règlement état")
                                                                                          ])),
                                                                                          _: 1
                                                                                        })
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1040))
                                                                                  : _createCommentVNode("", true)
                                                                              ]),
                                                                              _: 1
                                                                            }, 8, ["title", "companyId", "inAccountableAccountNames", "onClose"]))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getThirdPartyCompanyBTItem(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_divider, { key: 14 }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getThirdPartyCompanyBTItem(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_accountable_account, {
                                                                              key: 15,
                                                                              title: 
                                                                            _ctx.subAccountableAccountTitle
                                                                        ,
                                                                              defineThirdParty: true,
                                                                              showLabel: true,
                                                                              showValidation: false,
                                                                              companyId: 
                                                                            _ctx.selectedCompany.id
                                                                        ,
                                                                              inAccountableAccountType: 'Selected',
                                                                              embeddedInput: true,
                                                                              editAccountableAccount: 
                                                                            true
                                                                        ,
                                                                              inAccountableAccountNames: 
                                                                            _ctx.subSelectedAccountableAccounts
                                                                        ,
                                                                              activateFreeTag: true,
                                                                              onClose: 
                                                                            _ctx.closeAccountableAccount
                                                                        ,
                                                                              onSelectAccountableAccount: _cache[18] || (_cache[18] = ($event: any) => (
                                                                            _ctx.setAccountableAccount(
                                                                                $event,
                                                                            )
                                                                        ))
                                                                            }, {
                                                                              activator: _withCtx(({
                                                                                props,
                                                                            }) => [
                                                                                (
                                                                                    _ctx.getThirdPartyCompanyBTItem(
                                                                                        _ctx.selectedGroup,
                                                                                    )
                                                                                )
                                                                                  ? (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({
                                                                                      key: 0,
                                                                                      ref_for: true
                                                                                    }, props, {
                                                                                      onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (
                                                                                    _ctx.miscelleanousAccountableAccount(
                                                                                        _ctx.selectedGroup,
                                                                                    )
                                                                                ), ["stop"]))
                                                                                    }), {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_v_list_item_title, null, {
                                                                                          default: _withCtx(() => _cache[88] || (_cache[88] = [
                                                                                            _createTextVNode("Tous les comptes")
                                                                                          ])),
                                                                                          _: 1
                                                                                        })
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1040))
                                                                                  : _createCommentVNode("", true)
                                                                              ]),
                                                                              _: 1
                                                                            }, 8, ["title", "companyId", "inAccountableAccountNames", "onClose"]))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getThirdPartyCompanyBTItem(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_divider, { key: 16 }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getCurrentAccountBTItem(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 17,
                                                                              onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.currentAccountAccountableAccount =
                                                                                _ctx.getDefaultCurrentAccount();
                                                                            _ctx.showLinkWithCurrentAccountDialog =
                                                                                !_ctx.showLinkWithCurrentAccountDialog;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(_ctx.getCurrentAccountTitle()), 1)
                                                                                  ]),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getCurrentAccountBTItem(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 18,
                                                                              onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.currentAccountAccountableAccount =
                                                                                '467000';
                                                                            _ctx.showLinkWithCurrentAccountDialog =
                                                                                !_ctx.showLinkWithCurrentAccountDialog;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(_ctx.$t(
                                                                                "reconciliation.action.DEBIT_CREDIT_ACCOUNT",
                                                                            )), 1)
                                                                                  ]),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getCurrentAccountBTItem(
                                                                                _ctx.selectedGroup,
                                                                            ) ||
                                                                            _ctx.getCurrentAccountBTItem(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_divider, { key: 19 }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getCommissionBTItem(
                                                                                _ctx.selectedGroup,
                                                                            )
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 20,
                                                                              onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.showAddCommissionDialog =
                                                                                !_ctx.showAddCommissionDialog;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => _cache[89] || (_cache[89] = [
                                                                                    _createTextVNode("Commission")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getLoanBT(_ctx.selectedGroup)
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 21,
                                                                              onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.showAddLoanDialog =
                                                                                !_ctx.showAddLoanDialog;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(_ctx.getLoanBT(_ctx.selectedGroup)
                                                                                .bt.amount > 0
                                                                                ? "Versement du prêt"
                                                                                : "Remboursement emprunt"), 1)
                                                                                  ]),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getCommissionBTItem(
                                                                                _ctx.selectedGroup,
                                                                            ) ||
                                                                            _ctx.getLoanBT(_ctx.selectedGroup)
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_divider, { key: 22 }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getLoanBT(_ctx.selectedGroup)
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 23,
                                                                              onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.showCutAccountingLineDialog =
                                                                                !_ctx.showCutAccountingLineDialog;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              append: _withCtx(() => [
                                                                                _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                                  default: _withCtx(() => _cache[90] || (_cache[90] = [
                                                                                    _createTextVNode("$fa-cut")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => _cache[91] || (_cache[91] = [
                                                                                    _createTextVNode("Découper")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true),
                                                                        (
                                                                            _ctx.getLoanBT(_ctx.selectedGroup)
                                                                        )
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 24,
                                                                              onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => {
                                                                            _ctx.selectedGroup =
                                                                                _ctx.selectedGroup;
                                                                            _ctx.showAccountingItemDialog =
                                                                                !_ctx.showAccountingItemDialog;
                                                                        }, ["stop"]))
                                                                            }, {
                                                                              append: _withCtx(() => [
                                                                                _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                                  default: _withCtx(() => _cache[92] || (_cache[92] = [
                                                                                    _createTextVNode("$oss-edit")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => _cache[93] || (_cache[93] = [
                                                                                    _createTextVNode("Editer")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 1
                                                                            }))
                                                                          : _createCommentVNode("", true)
                                                                      ]),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["activator"]))
                                                              : _createCommentVNode("", true),
                                                            (
                                                                    _ctx.containsDocumentToValidate(item)
                                                                )
                                                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                  key: 1,
                                                                  onClick: _withModifiers(($event: any) => {
                                                                    _ctx.currentItem = item;
                                                                    _ctx.addRemoveReconciliationExpend(
                                                                        _ctx.containsDocumentToValidate(
                                                                            item,
                                                                        ),
                                                                    );
                                                                }, ["stop"])
                                                                }, {
                                                                  append: _withCtx(() => [
                                                                    _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                      default: _withCtx(() => _cache[95] || (_cache[95] = [
                                                                        _createTextVNode("$fa-thumbs-up")
                                                                      ])),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                      default: _withCtx(() => _cache[94] || (_cache[94] = [
                                                                        _createTextVNode("Valider le document")
                                                                      ])),
                                                                      _: 1
                                                                    })
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["onClick"]))
                                                              : (accountingItem.doc)
                                                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                    key: 2,
                                                                    onClick: _withModifiers(($event: any) => (
                                                                    _ctx.addRemoveReconciliationExpend(
                                                                        accountingItem,
                                                                    )
                                                                ), ["stop"])
                                                                  }, {
                                                                    append: _withCtx(() => [
                                                                      _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                        default: _withCtx(() => _cache[97] || (_cache[97] = [
                                                                          _createTextVNode("$fa-eye")
                                                                        ])),
                                                                        _: 1
                                                                      })
                                                                    ]),
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_v_list_item_title, null, {
                                                                        default: _withCtx(() => _cache[96] || (_cache[96] = [
                                                                          _createTextVNode("Afficher le document")
                                                                        ])),
                                                                        _: 1
                                                                      })
                                                                    ]),
                                                                    _: 2
                                                                  }, 1032, ["onClick"]))
                                                                : _createCommentVNode("", true),
                                                            (alIndex === 0)
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                  (
                                                                        !_ctx.containsDocumentToValidate(
                                                                            item,
                                                                        ) &&
                                                                        _ctx.showValidateReconciliation(
                                                                            item,
                                                                        )
                                                                    )
                                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                        key: 0,
                                                                        onClick: _withModifiers(($event: any) => (
                                                                        _ctx.validateReconciliation(item)
                                                                    ), ["stop"]),
                                                                        loading: _ctx.actionLoading
                                                                      }, {
                                                                        append: _withCtx(() => [
                                                                          _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                            default: _withCtx(() => _cache[98] || (_cache[98] = [
                                                                              _createTextVNode("$fa-thumbs-up")
                                                                            ])),
                                                                            _: 1
                                                                          })
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_list_item_title, null, {
                                                                            default: _withCtx(() => [
                                                                              _createTextVNode("Valider le lettrage" + _toDisplayString(_ctx.getReconciliationValidationType(
                                                                                item,
                                                                            ) ===
                                                                            "PENDING_VALIDATION_FROM_CLIENT"
                                                                                ? " client"
                                                                                : "") + " auto", 1)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["onClick", "loading"]))
                                                                    : _createCommentVNode("", true),
                                                                  (
                                                                        !_ctx.containsDocumentToValidate(
                                                                            item,
                                                                        ) &&
                                                                        _ctx.showValidateReconciliation(
                                                                            item,
                                                                        )
                                                                    )
                                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                        key: 1,
                                                                        onClick: _withModifiers(($event: any) => (
                                                                        _ctx.deleteReconciliation(item)
                                                                    ), ["stop"]),
                                                                        loading: _ctx.actionLoading
                                                                      }, {
                                                                        append: _withCtx(() => [
                                                                          _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                            default: _withCtx(() => _cache[99] || (_cache[99] = [
                                                                              _createTextVNode("$fa-thumbs-down")
                                                                            ])),
                                                                            _: 1
                                                                          })
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_list_item_title, null, {
                                                                            default: _withCtx(() => [
                                                                              _createTextVNode("Refuser le lettrage" + _toDisplayString(_ctx.getReconciliationValidationType(
                                                                                item,
                                                                            ) ===
                                                                            "PENDING_VALIDATION_FROM_CLIENT"
                                                                                ? " client "
                                                                                : "") + " auto", 1)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["onClick", "loading"]))
                                                                    : (
                                                                        _ctx.showRemoveCashbox(item)
                                                                    )
                                                                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                          key: 2,
                                                                          onClick: _withModifiers(($event: any) => (
                                                                        _ctx.removeCashbox(item)
                                                                    ), ["stop"]),
                                                                          loading: _ctx.actionLoading
                                                                        }, {
                                                                          append: _withCtx(() => [
                                                                            _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                              default: _withCtx(() => _cache[101] || (_cache[101] = [
                                                                                _createTextVNode("$fa-trash-alt")
                                                                              ])),
                                                                              _: 1
                                                                            })
                                                                          ]),
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_list_item_title, null, {
                                                                              default: _withCtx(() => _cache[100] || (_cache[100] = [
                                                                                _createTextVNode("Retirer de la caisse")
                                                                              ])),
                                                                              _: 1
                                                                            })
                                                                          ]),
                                                                          _: 2
                                                                        }, 1032, ["onClick", "loading"]))
                                                                      : (
                                                                        _ctx.showRemoveRemittance(item)
                                                                    )
                                                                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                            key: 3,
                                                                            onClick: _withModifiers(($event: any) => (
                                                                        _ctx.deleteReconciliation(item)
                                                                    ), ["stop"]),
                                                                            loading: _ctx.actionLoading
                                                                          }, {
                                                                            append: _withCtx(() => [
                                                                              _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                                default: _withCtx(() => _cache[103] || (_cache[103] = [
                                                                                  _createTextVNode("$fa-trash-alt")
                                                                                ])),
                                                                                _: 1
                                                                              })
                                                                            ]),
                                                                            default: _withCtx(() => [
                                                                              _createVNode(_component_v_list_item_title, null, {
                                                                                default: _withCtx(() => _cache[102] || (_cache[102] = [
                                                                                  _createTextVNode("Retirer du paiement par chèque")
                                                                                ])),
                                                                                _: 1
                                                                              })
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["onClick", "loading"]))
                                                                        : (
                                                                        _ctx.showRemoveCurrentAccount(
                                                                            item,
                                                                        )
                                                                    )
                                                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                              key: 4,
                                                                              onClick: _withModifiers(($event: any) => (
                                                                        _ctx.removeCurrentAccount(item)
                                                                    ), ["stop"])
                                                                            }, {
                                                                              append: _withCtx(() => [
                                                                                _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                                  default: _withCtx(() => _cache[104] || (_cache[104] = [
                                                                                    _createTextVNode("$fa-trash-alt")
                                                                                  ])),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              default: _withCtx(() => [
                                                                                _createVNode(_component_v_list_item_title, null, {
                                                                                  default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(_ctx.removeCurrentAccountTitle), 1)
                                                                                  ]),
                                                                                  _: 1
                                                                                })
                                                                              ]),
                                                                              _: 2
                                                                            }, 1032, ["onClick"]))
                                                                          : (
                                                                        _ctx.showDeleteReconciliation(
                                                                            item,
                                                                        )
                                                                    )
                                                                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                                key: 5,
                                                                                onClick: _withModifiers(($event: any) => (
                                                                        _ctx.deleteReconciliation(item)
                                                                    ), ["stop"])
                                                                              }, {
                                                                                append: _withCtx(() => [
                                                                                  _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                                    default: _withCtx(() => _cache[106] || (_cache[106] = [
                                                                                      _createTextVNode("$fa-trash-alt")
                                                                                    ])),
                                                                                    _: 1
                                                                                  })
                                                                                ]),
                                                                                default: _withCtx(() => [
                                                                                  _createVNode(_component_v_list_item_title, null, {
                                                                                    default: _withCtx(() => _cache[105] || (_cache[105] = [
                                                                                      _createTextVNode("Supprimer le lettrage")
                                                                                    ])),
                                                                                    _: 1
                                                                                  })
                                                                                ]),
                                                                                _: 2
                                                                              }, 1032, ["onClick"]))
                                                                            : (
                                                                        _ctx.showGroupNotReconciliatedAndWithImputation(
                                                                            item,
                                                                        ) &&
                                                                        _ctx.enableRemoveImputation(item)
                                                                    )
                                                                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                                  key: 6,
                                                                                  onClick: _withModifiers(($event: any) => (
                                                                        _ctx.removeImputation(item)
                                                                    ), ["stop"])
                                                                                }, {
                                                                                  append: _withCtx(() => [
                                                                                    _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                                      default: _withCtx(() => _cache[107] || (_cache[107] = [
                                                                                        _createTextVNode("$fa-trash-alt")
                                                                                      ])),
                                                                                      _: 1
                                                                                    })
                                                                                  ]),
                                                                                  default: _withCtx(() => [
                                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createTextVNode(_toDisplayString(_ctx.removeImputationTitle(item)), 1)
                                                                                      ]),
                                                                                      _: 2
                                                                                    }, 1024)
                                                                                  ]),
                                                                                  _: 2
                                                                                }, 1032, ["onClick"]))
                                                                              : _createCommentVNode("", true),
                                                                  (accountingItem.doc)
                                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                        key: 7,
                                                                        onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (
                                                                        _ctx.deallocateBankTransactions()
                                                                    ), ["stop"]))
                                                                      }, {
                                                                        append: _withCtx(() => [
                                                                          _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                            default: _withCtx(() => _cache[108] || (_cache[108] = [
                                                                              _createTextVNode("$fa-trash-alt")
                                                                            ])),
                                                                            _: 1
                                                                          })
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_list_item_title, null, {
                                                                            default: _withCtx(() => _cache[109] || (_cache[109] = [
                                                                              _createTextVNode("Retirer l'affectation")
                                                                            ])),
                                                                            _: 1
                                                                          })
                                                                        ]),
                                                                        _: 1
                                                                      }))
                                                                    : _createCommentVNode("", true),
                                                                  (_ctx.enableFixedAssets(item))
                                                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                                        key: 8,
                                                                        onClick: _withModifiers(($event: any) => (
                                                                        _ctx.openFixedAssets(item)
                                                                    ), ["stop"])
                                                                      }, {
                                                                        append: _withCtx(() => [
                                                                          _createVNode(_component_v_icon, { size: "x-small" }, {
                                                                            default: _withCtx(() => _cache[110] || (_cache[110] = [
                                                                              _createTextVNode("$fa-chevron-right")
                                                                            ])),
                                                                            _: 1
                                                                          })
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_list_item_title, null, {
                                                                            default: _withCtx(() => _cache[111] || (_cache[111] = [
                                                                              _createTextVNode("Amos")
                                                                            ])),
                                                                            _: 1
                                                                          })
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["onClick"]))
                                                                    : _createCommentVNode("", true)
                                                                ], 64))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ], 4))
                                                    : _createCommentVNode("", true)
                                                ], 12, _hoisted_3))
                                              }), 128))
                                            ]),
                                            "body.append": _withCtx(() => [
                                              _createElementVNode("tr", null, [
                                                _createElementVNode("td", {
                                                  colspan: "7",
                                                  style: _normalizeStyle(_ctx.getCellStyle(0, false))
                                                }, null, 4),
                                                (
                                                            _ctx.selectedCompany.solution !==
                                                                'MANAGEMENT' &&
                                                            _ctx.mode != 'GeneralLedger'
                                                        )
                                                  ? (_openBlock(), _createElementBlock("td", {
                                                      key: 0,
                                                      class: "d-flex align-center justify-center",
                                                      style: _normalizeStyle(_ctx.getCellStyle(0, false))
                                                    }, [
                                                      _createVNode(_component_v_tooltip, { location: "top" }, {
                                                        activator: _withCtx(({ props }) => [
                                                          (
                                                                        !_ctx.reconciliation ||
                                                                        !_ctx.reconciliation.id
                                                                    )
                                                            ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
                                                                key: 0,
                                                                rounded: "circle",
                                                                elevation: "0",
                                                                class: "mr-2",
                                                                onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (
                                                                        _ctx.setOpenChat(
                                                                            'INFORMATION_REQUEST',
                                                                        )
                                                                    ), ["stop"])),
                                                                size: "x-small"
                                                              }, props, { icon: "$oss-chat" }), null, 16))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _cache[112] || (_cache[112] = _createElementVNode("span", null, "Question", -1))
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_tooltip, { location: "top" }, {
                                                        activator: _withCtx(({ props }) => [
                                                          _createVNode(_component_v_btn_prev, _mergeProps({
                                                            disabled: _ctx.previousDisabled(),
                                                            onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.previous()), ["stop"]))
                                                          }, props), null, 16, ["disabled"])
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _cache[113] || (_cache[113] = _createElementVNode("span", null, "Précédent", -1))
                                                        ]),
                                                        _: 1
                                                      }),
                                                      (_ctx.toBeDoneStatus)
                                                        ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                            key: 0,
                                                            icon: "$stop",
                                                            elevation: "0",
                                                            color: "secondary",
                                                            onClick: _cache[28] || (_cache[28] = _withModifiers(($event: any) => (_ctx.back()), ["stop"])),
                                                            size: "small"
                                                          }))
                                                        : _createCommentVNode("", true),
                                                      _createVNode(_component_v_tooltip, { location: "top" }, {
                                                        activator: _withCtx(({ props }) => [
                                                          (_ctx.mode != 'GeneralLedger')
                                                            ? (_openBlock(), _createBlock(_component_v_btn_next, _mergeProps({
                                                                key: 0,
                                                                disabled: _ctx.nextDisabled(),
                                                                onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (_ctx.next()), ["stop"]))
                                                              }, props), null, 16, ["disabled"]))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _cache[114] || (_cache[114] = _createElementVNode("span", null, "Suivant", -1))
                                                        ]),
                                                        _: 1
                                                      })
                                                    ], 4))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["headers", "items", "loading"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_slide_y_transition, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _withDirectives(_createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_container, { fluid: "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_data_table, {
                                              headers: _ctx.suggestedDocumentHeaders,
                                              items: _ctx.suggestedDocuments,
                                              expanded: _ctx.suggestedDocumentExpanded,
                                              "onUpdate:expanded": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.suggestedDocumentExpanded) = $event)),
                                              "items-per-page-options": [5, 10, 25],
                                              class: "table",
                                              "fixed-header": "",
                                              "max-height": "60vh"
                                            }, {
                                              item: _withCtx((props) => [
                                                _createElementVNode("tr", null, [
                                                  _createElementVNode("td", {
                                                    class: "text-center",
                                                    onClick: _withModifiers(($event: any) => (
                                                                _ctx.addRemoveSuggestedDocumentExpand(
                                                                    props.item,
                                                                )
                                                            ), ["stop"])
                                                  }, _toDisplayString(props.item.name), 9, _hoisted_14),
                                                  _createElementVNode("td", {
                                                    class: "text-center",
                                                    onClick: _withModifiers(($event: any) => (
                                                                _ctx.addRemoveSuggestedDocumentExpand(
                                                                    props.item,
                                                                )
                                                            ), ["stop"])
                                                  }, _toDisplayString(props.item.date), 9, _hoisted_15),
                                                  _createElementVNode("td", {
                                                    class: "text-center",
                                                    onClick: _withModifiers(($event: any) => (
                                                                _ctx.addRemoveSuggestedDocumentExpand(
                                                                    props.item,
                                                                )
                                                            ), ["stop"])
                                                  }, _toDisplayString(props.item.debit
                                                                    ? _ctx.newCommonFormatCurrency(
                                                                          props.item.debit,
                                                                      )
                                                                    : "-"), 9, _hoisted_16),
                                                  _createElementVNode("td", {
                                                    class: "text-center",
                                                    onClick: _withModifiers(($event: any) => (
                                                                _ctx.addRemoveSuggestedDocumentExpand(
                                                                    props.item,
                                                                )
                                                            ), ["stop"])
                                                  }, _toDisplayString(props.item.credit
                                                                    ? _ctx.newCommonFormatCurrency(
                                                                          props.item.credit,
                                                                      )
                                                                    : "-"), 9, _hoisted_17),
                                                  _createElementVNode("td", {
                                                    class: "text-center",
                                                    onClick: _withModifiers(($event: any) => (
                                                                _ctx.replaceBySuggestedDocument(
                                                                    props.item,
                                                                )
                                                            ), ["stop"])
                                                  }, [
                                                    _createVNode(_component_v_btn, {
                                                      rounded: "",
                                                      dense: "",
                                                      color: "primary"
                                                    }, {
                                                      default: _withCtx(() => _cache[115] || (_cache[115] = [
                                                        _createTextVNode("Remplacer")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ], 8, _hoisted_18)
                                                ])
                                              ]),
                                              "expanded-row": _withCtx(({ columns, item }) => [
                                                _createElementVNode("td", {
                                                  colspan: columns.length
                                                }, [
                                                  (item.signedUrl)
                                                    ? (_openBlock(), _createBlock(_component_v_row, {
                                                        key: 0,
                                                        align: "center",
                                                        justify: "center"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_img, {
                                                            src: item.signedUrl,
                                                            "lazy-src": _imports_0,
                                                            width: "60vw",
                                                            contain: true,
                                                            class: "elevation-5 ma-4"
                                                          }, null, 8, ["src"])
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    : _createCommentVNode("", true)
                                                ], 8, _hoisted_19)
                                              ]),
                                              _: 1
                                            }, 8, ["headers", "items", "expanded"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 512), [
                                      [_vShow, _ctx.suggestedDocumentPanel]
                                    ]),
                                    _withDirectives(_createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        (_ctx.documentPanel)
                                          ? (_openBlock(), _createBlock(_component_DocumentReconciliator, {
                                              key: 0,
                                              itemReconciliations: _ctx.itemReconciliations,
                                              reconciliationItems: _ctx.reconciliationItems,
                                              companyId: _ctx.companyId,
                                              documentType: _ctx.reconciliatorDocumentType,
                                              amountSigned: _ctx.bankTransactionAmount,
                                              onAddAccountingLine: _cache[31] || (_cache[31] = ($event: any) => (_ctx.addAccountingLine($event)))
                                            }, null, 8, ["itemReconciliations", "reconciliationItems", "companyId", "documentType", "amountSigned"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 512), [
                                      [_vShow, _ctx.documentPanel]
                                    ]),
                                    _withDirectives(_createVNode(_component_v_card_text, {
                                      row: "",
                                      xs12: "",
                                      wrap: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_container, { fluid: "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_layout, {
                                              "align-center": "",
                                              class: "filter-layout pa-2",
                                              id: "documents-btFilter-box"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_flex, {
                                                  xs2: "",
                                                  "px-1": ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                      outlined: "",
                                                      "append-inner-icon": "$euro",
                                                      modelValue: _ctx.btFilter.amount.minimum,
                                                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.btFilter.amount.minimum) = $event)),
                                                      label: "Min",
                                                      class: "amount-filter margin",
                                                      type: "number",
                                                      "hide-details": true,
                                                      density: "compact"
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_flex, {
                                                  xs2: "",
                                                  "px-1": ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                      outlined: "",
                                                      "append-inner-icon": "$euro",
                                                      modelValue: _ctx.btFilter.amount.maximum,
                                                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.btFilter.amount.maximum) = $event)),
                                                      label: "Max",
                                                      class: "amount-filter margin",
                                                      type: "number",
                                                      "hide-details": true,
                                                      density: "compact"
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_flex, {
                                                  xs4: "",
                                                  "px-1": ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_oss_date_range_picker, {
                                                      begin: _ctx.btFilter.date.begin,
                                                      end: _ctx.btFilter.date.end,
                                                      dense: true,
                                                      onChangeDateRange: _ctx.onBTDateRangeChanged,
                                                      "hide-details": true
                                                    }, null, 8, ["begin", "end", "onChangeDateRange"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_flex, {
                                                  xs3: "",
                                                  "px-1": ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                      outlined: "",
                                                      modelValue: _ctx.btFilter.search,
                                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.btFilter.search) = $event)),
                                                      "append-inner-icon": "$search",
                                                      label: "Recherche",
                                                      "hide-details": true,
                                                      density: "compact"
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_flex, { "px-1": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_btn, {
                                                      rounded: "circle",
                                                      class: "elevation-0",
                                                      disabled: 
                                                            _ctx.isFiltered(_ctx.defaultBTFilter, _ctx.btFilter)
                                                        ,
                                                      onClick: _cache[35] || (_cache[35] = _withModifiers(($event: any) => (_ctx.clearBTFilters()), ["stop"])),
                                                      size: "small",
                                                      icon: "$clear"
                                                    }, null, 8, ["disabled"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_container, { fuild: "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_data_table_server, {
                                              headers: _ctx.selectionHeaders,
                                              items: _ctx.availableBankTransactions,
                                              page: _ctx.btFilter.pagination.page,
                                              "onUpdate:page": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.btFilter.pagination.page) = $event)),
                                              "sort-by": _ctx.btFilter.pagination.sortBy,
                                              "onUpdate:sortBy": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.btFilter.pagination.sortBy) = $event)),
                                              "items-per-page": 
                                                    _ctx.btFilter.pagination.rowsPerPage
                                                ,
                                              "onUpdate:itemsPerPage": _cache[38] || (_cache[38] = ($event: any) => ((
                                                    _ctx.btFilter.pagination.rowsPerPage
                                                ) = $event)),
                                              "items-length": _ctx.btFilter.pagination.totalItems,
                                              "items-per-page-options": [5, 10, 25],
                                              class: "table",
                                              "fixed-header": "",
                                              "max-height": "60vh"
                                            }, {
                                              "no-data": _withCtx(() => [
                                                _createVNode(_component_v_alert, {
                                                  color: "error",
                                                  icon: "warning",
                                                  "model-value": true
                                                }, {
                                                  default: _withCtx(() => _cache[116] || (_cache[116] = [
                                                    _createTextVNode("no item")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              item: _withCtx((props) => [
                                                _createElementVNode("tr", null, [
                                                  _createElementVNode("td", _hoisted_20, [
                                                    _createElementVNode("div", null, _toDisplayString(props.item.name), 1),
                                                    (props.item.suppliers)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, " Fournisseur: " + _toDisplayString(props.item.suppliers), 1))
                                                      : _createCommentVNode("", true),
                                                    (props.item.customers)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Client: " + _toDisplayString(props.item.customers), 1))
                                                      : _createCommentVNode("", true),
                                                    (props.item.user)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Collaborateur : " + _toDisplayString(props.item.user), 1))
                                                      : _createCommentVNode("", true),
                                                    (props.item.bankAccount)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Compte bancaire : " + _toDisplayString(props.item.bankAccount), 1))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _createElementVNode("td", _hoisted_25, _toDisplayString(props.item.date), 1),
                                                  _createElementVNode("td", _hoisted_26, _toDisplayString(props.item.debit
                                                                    ? _ctx.newCommonFormatCurrency(
                                                                          props.item.debit,
                                                                      )
                                                                    : "-"), 1),
                                                  _createElementVNode("td", _hoisted_27, _toDisplayString(props.item.credit
                                                                    ? _ctx.newCommonFormatCurrency(
                                                                          props.item.credit,
                                                                      )
                                                                    : "-"), 1)
                                                ])
                                              ]),
                                              _: 1
                                            }, 8, ["headers", "items", "page", "sort-by", "items-per-page", "items-length"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 512), [
                                      [_vShow, _ctx.bankTransactionPanel]
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_window_item, { value: 1 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.$vuetify.display.mobile)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": "",
                    class: "pa-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "d-flex flex-row pa-2"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_28, [
                            (_ctx.mode != 'GeneralLedger')
                              ? (_openBlock(), _createBlock(_component_v_btn_back, {
                                  key: 0,
                                  onClick: _cache[40] || (_cache[40] = _withModifiers(($event: any) => (_ctx.back()), ["stop"]))
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_card, { class: "default_card large elevation-0 fill-height pa-2 my-0" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedAccountingLines, (group, index) => {
                    return (_openBlock(), _createBlock(_component_v_row, {
                      "no-gutters": "",
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "10",
                          class: "font-weight-bold d-flex align-center header my-2 pl-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.groupStatus(group)), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_col, {
                          cols: "2",
                          class: "d-flex align-center justify-end mb-2"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.needsAction(group))
                              ? (_openBlock(), _createBlock(_component_v_menu, { key: 0 }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_btn_icon, _mergeProps({
                                      icon: "$dots_vertical",
                                      ref_for: true
                                    }, props), null, 16)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list, { density: "compact" }, {
                                      default: _withCtx(() => [
                                        (_ctx.getToReconciliateBTWithDocuments(group))
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 0,
                                              onClick: _withModifiers(($event: any) => {
                                        _ctx.selectedGroup = group;
                                        _ctx.documentPanel = !_ctx.documentPanel;
                                        _ctx.suggestedDocumentPanel = false;
                                        _ctx.bankTransactionPanel = false;
                                        _ctx.reconciliationPanel = false;
                                    }, ["stop"])
                                            }, {
                                              append: _withCtx(() => [
                                                _createVNode(_component_v_icon, { size: "x-small" }, {
                                                  default: _withCtx(() => _cache[117] || (_cache[117] = [
                                                    _createTextVNode("$fa-search")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => _cache[118] || (_cache[118] = [
                                                    _createTextVNode("Chercher un justificatif")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (_ctx.showSuggestedDocuments(group))
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 1,
                                              onClick: _withModifiers(($event: any) => {
                                        _ctx.selectedGroup = group;
                                        _ctx.suggestedDocumentPanel = !_ctx.suggestedDocumentPanel;
                                        _ctx.documentPanel = false;
                                        _ctx.bankTransactionPanel = false;
                                        _ctx.reconciliationPanel = false;
                                    }, ["stop"])
                                            }, {
                                              append: _withCtx(() => [
                                                _createVNode(_component_v_icon, { size: "x-small" }, {
                                                  default: _withCtx(() => _cache[119] || (_cache[119] = [
                                                    _createTextVNode("$fa-magic")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => _cache[120] || (_cache[120] = [
                                                    _createTextVNode("Justificatifs suggérés")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (_ctx.getWithoutInvoiceBT(group))
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 2,
                                              onClick: _withModifiers(($event: any) => {
                                        _ctx.selectedGroup = group;
                                        _ctx.showWithoutInvoiceDialog = !_ctx.showWithoutInvoiceDialog;
                                    }, ["stop"])
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => _cache[121] || (_cache[121] = [
                                                    _createTextVNode("Autre opération")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (
                                        _ctx.cashPaymentDocItem ||
                                        _ctx.cashWithdrawalBTItem ||
                                        _ctx.getZTillBT(group)
                                    )
                                          ? (_openBlock(), _createBlock(_component_v_divider, { key: 3 }))
                                          : _createCommentVNode("", true),
                                        (_ctx.getThirdPartyCompanyBTItem(group))
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 4,
                                              onClick: _withModifiers(($event: any) => {
                                        _ctx.selectedGroup = group;
                                        _ctx.companyType = 'SUPPLIER';
                                        _ctx.showThirdPartyCompanyDialog = !_ctx.showThirdPartyCompanyDialog;
                                    }, ["stop"])
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => _cache[122] || (_cache[122] = [
                                                    _createTextVNode("Règlement fournisseur")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (_ctx.getThirdPartyCompanyBTItem(group))
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 5,
                                              onClick: _withModifiers(($event: any) => {
                                        _ctx.selectedGroup = group;
                                        _ctx.companyType = 'CUSTOMER';
                                        _ctx.showThirdPartyCompanyDialog = !_ctx.showThirdPartyCompanyDialog;
                                    }, ["stop"])
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => _cache[123] || (_cache[123] = [
                                                    _createTextVNode("Règlement client")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (_ctx.getThirdPartyCompanyBTItem(group))
                                          ? (_openBlock(), _createBlock(_component_v_divider, { key: 6 }))
                                          : _createCommentVNode("", true),
                                        (_ctx.getThirdPartyCompanyBTItem(group))
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 7,
                                              onClick: _withModifiers(($event: any) => (_ctx.socialAccountableAccount(group)), ["stop"])
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => _cache[124] || (_cache[124] = [
                                                    _createTextVNode("Règlement social")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (_ctx.getThirdPartyCompanyBTItem(group))
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 8,
                                              onClick: _withModifiers(($event: any) => (_ctx.stateAccountableAccount(group)), ["stop"])
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => _cache[125] || (_cache[125] = [
                                                    _createTextVNode("Règlement état")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (
                                        _ctx.getCurrentAccountBTItem(group) ||
                                        _ctx.getCurrentAccountBTItem(group)
                                    )
                                          ? (_openBlock(), _createBlock(_component_v_divider, { key: 9 }))
                                          : _createCommentVNode("", true),
                                        (_ctx.getCommissionBTItem(group))
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 10,
                                              onClick: _withModifiers(($event: any) => {
                                        _ctx.selectedGroup = group;
                                        _ctx.showAddCommissionDialog = !_ctx.showAddCommissionDialog;
                                    }, ["stop"])
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => _cache[126] || (_cache[126] = [
                                                    _createTextVNode("Commission")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        (_ctx.getLoanBT(group))
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 11,
                                              onClick: _withModifiers(($event: any) => {
                                        _ctx.selectedGroup = group;
                                        _ctx.showAddLoanDialog = !_ctx.showAddLoanDialog;
                                    }, ["stop"])
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.getLoanBT(group).bt.amount > 0
                                            ? "Versement du prêt"
                                            : "Remboursement emprunt"), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item, index) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            cols: "12",
                            key: index
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                class: "default_card_wm mx-auto pa-2 mb-2",
                                style: {"background":"#fff !important","border":"solid rgba(0, 0, 0, 0.12) 1px","box-shadow":"none"},
                                onClick: _withModifiers(($event: any) => (
                                _ctx.addRemoveReconciliationExpend(_ctx.containsDocumentToValidate(group))
                            ), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "1",
                                        class: "d-flex align-center justify-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            small: true,
                                            class: "mr-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.formatIconName(item.iconType)), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, { cols: "11" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_29, [
                                            _createElementVNode("div", null, [
                                              (
                                                    (item.bt && item.bt.accountingItemImport) ||
                                                    (item.doc && item.doc.accountingItemImport)
                                                )
                                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                                    key: 0,
                                                    label: "",
                                                    color: "grey",
                                                    class: "mr-2",
                                                    size: "small",
                                                    variant: "outlined"
                                                  }, {
                                                    default: _withCtx(() => _cache[127] || (_cache[127] = [
                                                      _createTextVNode(" Importé ")
                                                    ])),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true),
                                              _createTextVNode(" " + _toDisplayString(item.name), 1)
                                            ]),
                                            (item.doc && _ctx.containsDocumentToValidate(group))
                                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                                  key: 0,
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => _cache[128] || (_cache[128] = [
                                                    _createTextVNode("Document non validé")
                                                  ])),
                                                  _: 1
                                                }))
                                              : (item.doc)
                                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                                    key: 1,
                                                    color: "secondary",
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[129] || (_cache[129] = [
                                                      _createTextVNode("$oss-circle-check")
                                                    ])),
                                                    _: 1
                                                  }))
                                                : _createCommentVNode("", true)
                                          ]),
                                          (item.bt)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                (item.suppliers)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Fournisseur: " + _toDisplayString(item.suppliers), 1))
                                                  : _createCommentVNode("", true),
                                                (item.customers)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Client: " + _toDisplayString(item.customers), 1))
                                                  : _createCommentVNode("", true),
                                                (item.user)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Collaborateur : " + _toDisplayString(item.user), 1))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (item.doc)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                (item.doc.type === 'WITHOUT_INVOICE')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Sans justificatif"))
                                                  : (item.doc.type === 'SALES_INVOICE_AUTO')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Encaissemment"))
                                                    : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_row, {
                                    "no-gutters": "",
                                    class: "mt-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex justify-space-between pr-3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.date), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex justify-end pr-3 font-weight-bold"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(item.debit ? _ctx.newCommonFormatCurrency(item.debit) : "-") + " D", 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, {
                                        cols: "4",
                                        class: "d-flex justify-end pl-3 font-weight-bold"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(item.credit ? _ctx.newCommonFormatCurrency(item.credit) : "-") + " C", 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        (_ctx.showValidateReconciliation(group))
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "12",
                              class: "d-flex mt-3 justify-space-between"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  elevation: "0",
                                  rounded: "",
                                  outlined: "",
                                  disabled: _ctx.containsDocumentToValidate(group),
                                  size: "small",
                                  onClick: _withModifiers(($event: any) => (_ctx.deleteReconciliation(group)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Refuser le lettrage" + _toDisplayString(_ctx.getReconciliationValidationType(group) ===
                                "PENDING_VALIDATION_FROM_CLIENT"
                                    ? " client"
                                    : "") + " ", 1),
                                    _createVNode(_component_v_icon, {
                                      size: "x-small",
                                      location: "end"
                                    }, {
                                      default: _withCtx(() => _cache[130] || (_cache[130] = [
                                        _createTextVNode("$fa-thumbs-down")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "onClick"]),
                                _createVNode(_component_v_btn, {
                                  elevation: "0",
                                  rounded: "",
                                  disabled: _ctx.containsDocumentToValidate(group),
                                  size: "small",
                                  onClick: _withModifiers(($event: any) => (_ctx.validateReconciliation(group)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Valider le lettrage" + _toDisplayString(_ctx.getReconciliationValidationType(group) ===
                                "PENDING_VALIDATION_FROM_CLIENT"
                                    ? " client"
                                    : "") + " ", 1),
                                    _createVNode(_component_v_icon, {
                                      size: "x-small",
                                      location: "end"
                                    }, {
                                      default: _withCtx(() => _cache[131] || (_cache[131] = [
                                        _createTextVNode("$fa-thumbs-up")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ], 64)),
        (_ctx.openChat)
          ? (_openBlock(), _createBlock(_component_Chat, {
              key: 2,
              id: _ctx.chatId,
              inShowMessage: _ctx.open_chat,
              chatTitle: 'Ligne bancaire',
              chatSubtitle: _ctx.getChatSubTitle(),
              showSmartChat: _ctx.wishStatus !== 'DENIED',
              onMessageSent: _cache[41] || (_cache[41] = ($event: any) => (_ctx.onMessageSent($event))),
              onShowMessageChanged: _cache[42] || (_cache[42] = ($event: any) => (_ctx.onShowMessageChanged($event)))
            }, null, 8, ["id", "inShowMessage", "chatSubtitle", "showSmartChat"]))
          : _createCommentVNode("", true),
        _createVNode(_component_oss_dialog, {
          modelValue: _ctx.showWithoutInvoiceDialog,
          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.showWithoutInvoiceDialog) = $event)),
          title: 'Sans facture',
          actions: _ctx.withoutInvoiceActions,
          width: "800px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_WithoutInvoice, {
              companyId: _ctx.companyId,
              btItem: _ctx.getWithoutInvoiceBT(_ctx.selectedGroup),
              actions: _ctx.withoutInvoiceActions,
              onAdded: _cache[43] || (_cache[43] = ($event: any) => {
                    _ctx.showWithoutInvoiceDialog = false;
                    _ctx.refresh();
                })
            }, null, 8, ["companyId", "btItem", "actions"])
          ]),
          _: 1
        }, 8, ["modelValue", "actions"]),
        (_ctx.selectedGroup && _ctx.getThirdPartyCompanyBTItem(_ctx.selectedGroup))
          ? (_openBlock(), _createBlock(_component_ThirdPartyCompany, {
              key: 3,
              modelValue: _ctx.showThirdPartyCompanyDialog,
              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.showThirdPartyCompanyDialog) = $event)),
              companyId: _ctx.companyId,
              companyType: _ctx.companyType,
              btItem: _ctx.getThirdPartyCompanyBTItem(_ctx.selectedGroup),
              activateFreeTag: true,
              onAdded: _cache[46] || (_cache[46] = ($event: any) => (_ctx.onThirdPartyCompanyChanged()))
            }, null, 8, ["modelValue", "companyId", "companyType", "btItem"]))
          : _createCommentVNode("", true),
        _createVNode(_component_oss_dialog, {
          modelValue: _ctx.autoSalesReconciliation,
          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.autoSalesReconciliation) = $event)),
          title: 'Encaissement',
          actions: _ctx.autoSalesActions,
          width: "800px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_AutoSales, {
              companyId: _ctx.companyId,
              btItem: _ctx.showAutoSalesReconciliation(_ctx.selectedGroup),
              actions: _ctx.autoSalesActions,
              onAdded: _cache[47] || (_cache[47] = ($event: any) => {
                    _ctx.autoSalesReconciliation = false;
                    _ctx.refresh();
                })
            }, null, 8, ["companyId", "btItem", "actions"])
          ]),
          _: 1
        }, 8, ["modelValue", "actions"]),
        (_ctx.showAddCommissionDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 4,
              modelValue: _ctx.showAddCommissionDialog,
              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.showAddCommissionDialog) = $event)),
              title: 'Commission',
              actions: _ctx.commissionActions,
              width: "800px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Commission, {
                  reconciliationVue: _ctx.reconciliationVue,
                  companyId: _ctx.companyId,
                  btItem: _ctx.getCommissionBTItem(_ctx.selectedGroup),
                  actions: _ctx.commissionActions,
                  onAdded: _cache[49] || (_cache[49] = ($event: any) => (_ctx.showAddCommissionDialog = false))
                }, null, 8, ["reconciliationVue", "companyId", "btItem", "actions"])
              ]),
              _: 1
            }, 8, ["modelValue", "actions"]))
          : _createCommentVNode("", true),
        (_ctx.showAddLoanDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 5,
              modelValue: _ctx.showAddLoanDialog,
              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.showAddLoanDialog) = $event)),
              title: 'Emprunt',
              actions: _ctx.loanActions,
              width: "800px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Loan, {
                  reconciliationVue: _ctx.reconciliationVue,
                  companyId: _ctx.companyId,
                  btItem: _ctx.getLoanBT(_ctx.selectedGroup),
                  actions: _ctx.loanActions,
                  onAdded: _cache[51] || (_cache[51] = ($event: any) => (_ctx.showAddLoanDialog = false))
                }, null, 8, ["reconciliationVue", "companyId", "btItem", "actions"])
              ]),
              _: 1
            }, 8, ["modelValue", "actions"]))
          : _createCommentVNode("", true),
        (_ctx.showCutAccountingLineDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 6,
              modelValue: _ctx.showCutAccountingLineDialog,
              "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.showCutAccountingLineDialog) = $event)),
              title: 'Découper',
              actions: _ctx.cutAccountingLineActions,
              width: "800px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CutAccountingLine, {
                  reconciliationVue: _ctx.reconciliationVue,
                  companyId: _ctx.companyId,
                  btItem: _ctx.getLoanBT(_ctx.selectedGroup),
                  actions: _ctx.cutAccountingLineActions,
                  onAdded: _cache[53] || (_cache[53] = ($event: any) => (_ctx.showCutAccountingLineDialog = false))
                }, null, 8, ["reconciliationVue", "companyId", "btItem", "actions"])
              ]),
              _: 1
            }, 8, ["modelValue", "actions"]))
          : _createCommentVNode("", true),
        (_ctx.showAccountingItemDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 7,
              modelValue: _ctx.showAccountingItemDialog,
              "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.showAccountingItemDialog) = $event)),
              actions: _ctx.accountingItemActions,
              width: "90vw"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AccountingItemEdition2, {
                  companyId: _ctx.companyId,
                  bankTransactionId: _ctx.getLoanBT(_ctx.selectedGroup).bt.id,
                  actions: _ctx.accountingItemActions,
                  onUpsert: _cache[55] || (_cache[55] = 
                    () => {
                        _ctx.showAccountingItemDialog = false;
                        _ctx.refresh();
                    }
                )
                }, null, 8, ["companyId", "bankTransactionId", "actions"])
              ]),
              _: 1
            }, 8, ["modelValue", "actions"]))
          : _createCommentVNode("", true),
        (_ctx.showZTillDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 8,
              modelValue: _ctx.showZTillDialog,
              "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.showZTillDialog) = $event)),
              title: 'Affecter à la caisse',
              actions: _ctx.zTillActions,
              width: "800px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ZTill, {
                  reconciliationVue: _ctx.reconciliationVue,
                  zTillBT: _ctx.getZTillBT(_ctx.selectedGroup),
                  actions: _ctx.zTillActions,
                  onAdded: _cache[57] || (_cache[57] = ($event: any) => (_ctx.showZTillDialog = false))
                }, null, 8, ["reconciliationVue", "zTillBT", "actions"])
              ]),
              _: 1
            }, 8, ["modelValue", "actions"]))
          : _createCommentVNode("", true),
        (_ctx.showLinkWithCurrentAccountDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 9,
              modelValue: _ctx.showLinkWithCurrentAccountDialog,
              "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.showLinkWithCurrentAccountDialog) = $event)),
              title: 
                _ctx.currentAccountAccountableAccount === '467000'
                    ? _ctx.$t('reconciliation.action.DEBIT_CREDIT_ACCOUNT')
                    : _ctx.getCurrentAccountTitle()
            ,
              actions: _ctx.currentAccountActions,
              width: "800px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CurrentAccount, {
                  reconciliationVue: _ctx.reconciliationVue,
                  accountableAccount: _ctx.currentAccountAccountableAccount,
                  companyId: _ctx.companyId,
                  actions: _ctx.currentAccountActions,
                  onAdded: _cache[59] || (_cache[59] = ($event: any) => (_ctx.showLinkWithCurrentAccountDialog = false))
                }, null, 8, ["reconciliationVue", "accountableAccount", "companyId", "actions"])
              ]),
              _: 1
            }, 8, ["modelValue", "title", "actions"]))
          : _createCommentVNode("", true),
        (_ctx.showCashPaymentDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 10,
              modelValue: _ctx.showCashPaymentDialog,
              "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.showCashPaymentDialog) = $event)),
              title: 'Règlement en espèce',
              actions: _ctx.cashPaymentActions,
              width: "800px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CashPayment, {
                  userId: _ctx.currentUser.id,
                  companyId: _ctx.companyId,
                  accountingLine: _ctx.cashPaymentDocItem.accountingLine,
                  actions: _ctx.cashPaymentActions,
                  onAdded: _cache[61] || (_cache[61] = ($event: any) => (_ctx.onCashPaymentDone()))
                }, null, 8, ["userId", "companyId", "accountingLine", "actions"])
              ]),
              _: 1
            }, 8, ["modelValue", "actions"]))
          : _createCommentVNode("", true),
        (_ctx.showRemittanceDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 11,
              modelValue: _ctx.showRemittanceDialog,
              "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.showRemittanceDialog) = $event)),
              title: 'Règlement par chèque non encaissé',
              actions: _ctx.chequePaymentActions,
              width: "800px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Remittance, {
                  reconciliationVue: _ctx.reconciliationVue,
                  companyId: _ctx.companyId,
                  actions: _ctx.chequePaymentActions,
                  onAdded: _cache[63] || (_cache[63] = ($event: any) => (_ctx.onRemittanceDone()))
                }, null, 8, ["reconciliationVue", "companyId", "actions"])
              ]),
              _: 1
            }, 8, ["modelValue", "actions"]))
          : _createCommentVNode("", true),
        (_ctx.showCashWithdrawalDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 12,
              modelValue: _ctx.showCashWithdrawalDialog,
              "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.showCashWithdrawalDialog) = $event)),
              title: 'Retrait en espèce',
              actions: _ctx.cashWithdrawalActions,
              width: "800px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CashWithdrawal, {
                  reconciliationVue: _ctx.reconciliationVue,
                  companyId: _ctx.companyId,
                  actions: _ctx.cashWithdrawalActions,
                  onAdded: _cache[65] || (_cache[65] = ($event: any) => (_ctx.showCashWithdrawalDialog = false))
                }, null, 8, ["reconciliationVue", "companyId", "actions"])
              ]),
              _: 1
            }, 8, ["modelValue", "actions"]))
          : _createCommentVNode("", true),
        (_ctx.documentDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 13,
              modelValue: _ctx.documentDialog,
              "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.documentDialog) = $event)),
              withoutHeader: true,
              transition: "dialog-bottom-transition",
              "min-height": "95vh",
              "min-width": "95vw"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  class: "d-flex justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      style: {"overflow-y":"auto"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_document, {
                          mode: 'Reconciliation',
                          companyId: _ctx.selectedCompany.id,
                          id: _ctx.selectedDocument.id,
                          "dark-mode": true,
                          onTaskEnded: _ctx.onDocumentValidated
                        }, null, 8, ["companyId", "id", "onTaskEnded"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.showIOPBTDialog)
          ? (_openBlock(), _createBlock(_component_IOPBankTransactionDialog, {
              key: 14,
              modelValue: _ctx.showIOPBTDialog,
              "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.showIOPBTDialog) = $event)),
              selectedBankTransaction: _ctx.bankTransaction,
              selectedCompany: _ctx.selectedCompany,
              onBankTransactionChanged: _cache[69] || (_cache[69] = ($event: any) => (_ctx.onBankTransactionChanged()))
            }, null, 8, ["modelValue", "selectedBankTransaction", "selectedCompany"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}